const CURRENT_HOST = window.location.host

const getHostInfo = () => {
  let envName = 'l'

  let apiUrl = 'https://api.live.local'

  const envType = []

  if (CURRENT_HOST.includes('-dev') || CURRENT_HOST.includes('dev.')) {
    envName = 'd'
    apiUrl = `https://intelligent-calories-api-dev.cyberdog.top`
  } else if (!CURRENT_HOST.includes('local')) {
    envName = 'p'

    apiUrl = `https://intelligent-calories-api.cyberdog.top`
  }

  //
  //

  return { apiUrl, envName, envType }
}

const HOST_INFO = getHostInfo()

export const API_URL = HOST_INFO.apiUrl
export const ENV_SHORT_NAME = HOST_INFO.envName

export const IS_LOCAL_ENV = ENV_SHORT_NAME === 'l'
export const IS_DEV_ENV = IS_LOCAL_ENV || ENV_SHORT_NAME === 'd'
export const IS_PROD_ENV = ENV_SHORT_NAME === 'p'

//
//

// const PREFIX = 'ca'

// export const COOKIE_CSRF = `${ENV_SHORT_NAME}_${PREFIX}-csrf`
